import React from "react";
import { useDispatch, useSelector } from "react-redux";
import InfoCard from "../InfoCard";
import Pagination from "../../../../components/Pagination";
import setPageNumber from "../../../../store/public-directory/actions/setPageNumber";
import { RootState } from "../../../../store/reducers";
import { TabConfig } from "../../utils/TabConfigs";
import RowCard from "../RowCard";
import useMegatron from "../../../../hooks/useMegatron";
import styles from './MainContent.module.scss'
import { companyCreate } from "../../../../components/Paths/paths";
import bannerImage from '../../../../assets/bannerImagePublicDirectory.png'
interface MainContentProps {
  readonly config: TabConfig;
}

const MainContent = ({ config }: MainContentProps) => {
  const { response, pageNumber } = useSelector((state: RootState) => state.pd);
  const dispatch = useDispatch();
  const {isMegatronFeaturedOn, isLoading} = useMegatron();
  if (!response) {
    return (
    <>
    {isMegatronFeaturedOn && <div className={styles.bannerStyles}>
              <img src={bannerImage} alt="BRCGS Banner Image" className={styles.imageStyles}/>
              <div className={styles.buttonGroup}>
              <button>
                <a href={companyCreate}>Create a free account</a>
              </button>
              <button>
                <a href={`/private`}>Log in to Directory</a>
              </button>
              </div>
            </div>}
    <InfoCard bulletPoints={config.searchHelpText} Message={config.Message} headerText={isMegatronFeaturedOn && !isLoading ? "Find a BRCGS approved certification body" : ""}/>
    </>
    )
  }

  if (response.resultsList.length > 0) {
    return (
      <>
        {response.resultsList.map((item) => (
          <RowCard key={item.key} item={item} />
        ))}
        <Pagination
          pageCount={response?.totalPages ?? 0}
          page={pageNumber}
          onChange={(e: React.ChangeEvent<unknown>, p: number) =>
            dispatch(setPageNumber(p))
          }
        />
      </>
    )
  }

  return (
    <InfoCard mainText="No result has been found that matches your search, please try again" />
  );
};

export default MainContent;
